import {
  FETCH_EMISSIONS,
  FETCH_EMISSIONS_ERROR,
  FETCH_EMISSIONS_SUCCESS,
  TokenEmissionsActionTypes,
  UPDATE_EMISSION,
  UPDATE_EMISSION_ERROR,
  UPDATE_EMISSION_SUCCESS,
  ADD_EMISSION,
  EmissionType,
} from '../../../types/actions/Token/Emissions.actions';
import {ITokenEmission} from '../../../types/models/Emission';

export interface TokenEmissionsState {
  data: ITokenEmission[] | null;
  isLoading: boolean;
  isMinting: boolean;
  isBurning: boolean;
}

const initialState: TokenEmissionsState = {
  isLoading: false,
  isMinting: false,
  isBurning: false,
  data: null,
};

export default (
  state = initialState,
  action: TokenEmissionsActionTypes,
): TokenEmissionsState => {
  switch (action.type) {
    case FETCH_EMISSIONS: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case FETCH_EMISSIONS_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    }

    case FETCH_EMISSIONS_ERROR: {
      return {
        ...state,
        isLoading: false,
        data: null,
      };
    }

    case UPDATE_EMISSION:
      return action.payload === EmissionType.BURN
        ? {...state, isBurning: true}
        : {...state, isMinting: true};

    case UPDATE_EMISSION_ERROR:
    case UPDATE_EMISSION_SUCCESS:
      return action.payload === EmissionType.BURN
        ? {...state, isBurning: false}
        : {...state, isMinting: false};
    case ADD_EMISSION: {
      if (state.data) {
        return {
          ...state,
          data: [action.payload, ...state.data],
        };
      } else {
        return {
          ...state,
          data: [action.payload],
        };
      }
    }
    default:
      return state;
  }
};
